window.PH = window.PH || {};

(function () {
  const SEARCH_DELAY = 700;

  let searchTimer = null;
  let lastSearchKey = '';
  let lastProductSelectKey = '';
  let lastPackageAddKey = '';

  function track(eventName, parameters = {}) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      ...parameters
    });

    window.PH?.log?.(`[Analytics] ${eventName}`, parameters);
  }

  function getPackageSize() {
    return (
      window.PH &&
      PH.state &&
      Number(PH.state.limit)
        ? Number(PH.state.limit)
        : 0
    );
  }

  function getSelectedProducts() {
    return (
      window.PH &&
      PH.state &&
      Array.isArray(PH.state.selected)
        ? PH.state.selected
        : []
    );
  }

  function getSelectedCount() {
    return getSelectedProducts().length;
  }

  function getResultCount() {
    const container = document.querySelector(
      '[data-ph-search-results]'
    );

    if (!container) return 0;

    return container.querySelectorAll(
      '[data-ph-add-fragrance], .ph-search-result'
    ).length;
  }

  function getProductData(element) {
    if (!element) {
      return {
        product_id: '',
        product_name: '',
        product_handle: '',
        product_url: ''
      };
    }

    const resultCard = element.closest(
      '.ph-search-result, [data-ph-search-result], [data-product-card]'
    );

    const source = resultCard || element;

    const productId =
      element.dataset.productId ||
      element.dataset.id ||
      source.dataset.productId ||
      source.dataset.id ||
      '';

    const productName =
      element.dataset.productTitle ||
      element.dataset.productName ||
      element.dataset.title ||
      element.dataset.name ||
      source.dataset.productTitle ||
      source.dataset.productName ||
      source.dataset.title ||
      source.dataset.name ||
      source.querySelector(
        '.ph-search-result__title, [data-product-title], h2, h3, strong'
      )?.textContent?.trim() ||
      element.getAttribute('aria-label') ||
      element.textContent?.trim() ||
      '';

    const productHandle =
      element.dataset.productHandle ||
      element.dataset.handle ||
      source.dataset.productHandle ||
      source.dataset.handle ||
      '';

    const productLink =
      source.querySelector('a[href*="/products/"]') ||
      element.closest('a[href*="/products/"]');

    const productUrl =
      element.dataset.productUrl ||
      source.dataset.productUrl ||
      productLink?.getAttribute('href') ||
      '';

    return {
      product_id: String(productId),
      product_name: String(productName).replace(/\s+/g, ' ').trim(),
      product_handle: String(productHandle),
      product_url: String(productUrl)
    };
  }

  function getSelectedProductNames() {
    return getSelectedProducts()
      .map(function (item) {
        if (typeof item === 'string') return item;

        return (
          item.title ||
          item.name ||
          item.product_title ||
          item.handle ||
          item.id ||
          ''
        );
      })
      .filter(Boolean)
      .join(' | ');
  }

  /*
   * EVENTO 1:
   * Búsquedas con resultados o sin resultados.
   */
  document.addEventListener('input', function (event) {
    const input = event.target.closest(
      '[data-ph-search-input]'
    );

    if (!input) return;

    window.clearTimeout(searchTimer);

    const searchTerm = String(input.value || '').trim();

    if (searchTerm.length < 2) return;

    searchTimer = window.setTimeout(function () {
      const resultCount = getResultCount();

      const eventName =
        resultCount > 0
          ? 'ph_search'
          : 'ph_search_empty';

      const packageSize = getPackageSize();
      const selectedCount = getSelectedCount();

      const searchKey = [
        eventName,
        searchTerm.toLowerCase(),
        resultCount,
        packageSize,
        selectedCount
      ].join(':');

      if (lastSearchKey === searchKey) return;

      lastSearchKey = searchKey;

      track(eventName, {
        search_term: searchTerm,
        result_count: resultCount,
        package_size: packageSize,
        selected_count: selectedCount,
        search_source: 'package_builder',
        page_path: window.location.pathname
      });
    }, SEARCH_DELAY);
  });

  /*
   * EVENTO 2:
   * Selección de un perfume desde los resultados.
   */
  document.addEventListener('click', function (event) {
    const selectButton = event.target.closest(
      '[data-ph-add-fragrance]'
    );

    if (!selectButton) return;

    const product = getProductData(selectButton);
    const packageSize = getPackageSize();
    const selectedCountBefore = getSelectedCount();

    const productSelectKey = [
      product.product_id,
      product.product_name,
      product.product_handle,
      selectedCountBefore,
      Date.now()
    ].join(':');

    if (lastProductSelectKey === productSelectKey) return;

    lastProductSelectKey = productSelectKey;

    track('ph_product_select', {
      product_id: product.product_id,
      product_name: product.product_name,
      product_handle: product.product_handle,
      product_url: product.product_url,
      package_size: packageSize,
      selected_count_before: selectedCountBefore,
      selected_count_after: selectedCountBefore + 1,
      selection_source: 'search_results',
      page_path: window.location.pathname
    });
  });

  /*
   * EVENTO 3:
   * Clic final para agregar el paquete completo al carrito.
   */
  document.addEventListener('click', function (event) {
    const addToCartButton = event.target.closest(
      [
        '[data-ph-package-add-to-cart]',
        '[data-ph-add-package-to-cart]',
        '[data-package-add-to-cart]',
        'button[name="add"]',
        'form[action*="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] input[type="submit"]'
      ].join(', ')
    );

    if (!addToCartButton) return;

    const packageSize = getPackageSize();
    const selectedCount = getSelectedCount();

    /*
     * Evita disparar este evento en productos normales.
     * Solo se genera cuando existe un paquete PH configurado.
     */
    if (!packageSize || selectedCount < packageSize) return;

    const selectedProducts = getSelectedProductNames();

    const packageAddKey = [
      packageSize,
      selectedCount,
      selectedProducts
    ].join(':');

    if (lastPackageAddKey === packageAddKey) return;

    lastPackageAddKey = packageAddKey;

    track('ph_package_add_to_cart', {
      package_size: packageSize,
      selected_count: selectedCount,
      selected_products: selectedProducts,
      package_complete: selectedCount >= packageSize,
      add_source: 'package_builder',
      page_path: window.location.pathname
    });

    window.setTimeout(function () {
      lastPackageAddKey = '';
    }, 2000);
  });

  window.PHAnalytics = {
    track
  };

  window.PH?.log?.('Analytics inicializado');
})();
